export const CHECKOUT_FORM = "payment_collection_checkout";
export const ADD_CARD_FORM = "payment_collection_add_card";
export const RESEND_FORM = "payment_collection_resend_payment_request";
